import { CourseMember } from '../microsoft-graph/course/CourseService';
import { WorkgroupMember } from '../mnspro-cloud/api/v2';

export const SERVICEUSER_PREFIX = 'mnsprocloud_service';

export const filterNonServiceUsers = <T>(
  items: T[],
  propertySelector: (item: T) => string,
): T[] => {
  return items.filter(
    item => !propertySelector(item).startsWith(SERVICEUSER_PREFIX),
  );
};

export const removeServiceUserFromCourseMembers = (
  members: CourseMember[],
): CourseMember[] => {
  return filterNonServiceUsers(members, member => member.userPrincipalName);
};

export const removeServiceUserFromWorkgroupMembers = (
  members: WorkgroupMember[],
): WorkgroupMember[] => {
  return filterNonServiceUsers(members, member => member.mail);
};
